import { DateRange, GetReportRequestModel } from "../../../domain/model/Product";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { ReportRepository } from "./ReportRepository";

export class ReportRepositoryImpl implements ReportRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  getPerProduct(model: GetReportRequestModel): Promise<Response<Blob>> {
    return this.apiService.getPerProductReport(model);
  }
  getPerStore(dateRange?: DateRange): Promise<Response<Blob>> {
    return this.apiService.getPerStoreReport(dateRange);
  }
}
